import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-container">
      <div className="landing-content">
        <h1 className="landing-title">LTS by Loenhart Health</h1>
        
        <div className="landing-description">
          <p>
            Empower your Health and Fitness with LTS - a training program 
            tracker designed to help you take control of your health through structured, 
            purposeful exercise.
          </p>
        </div>

        <div className="cta-container">
          <h2>Join Our Beta Program</h2>
          <p>Join our beta program and experience a better way of exercise programming.</p>
          <div className="cta-buttons">
            <Link to="/register" className="cta-button register">
              Sign Up Now
            </Link>
            <Link to="/login" className="cta-button login">
              Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage; 